export default "__VITE_ASSET__DJfNU1FD__"